<div data-target="requestPassword" cdkTrapFocus [attr.aria-modal]="true">
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>

      <section class="dt-l-article__section">
        <ng-container *ngIf="!passwordRequested">
          <h1 class="dt-l-article__section__title" tabindex="-1">
            {{ 'PAGE_HEADING' | translate }}
          </h1>
          <p class="dt-l-article__section__description" [innerHtml]="pageSubheading"></p>
          <form id="requestpassword" [formGroup]="emailForm">
            <div class="dt-f-item type:email" [ngClass]="{ 'has-focus': hasFocus }">
              <label [attr.id]="'input-email'" for="email" class="dt-f-item__label"> {{ 'EMAIL' | translate }} </label>
              <div class="dt-f-item__element">
                <div class="dt-f-item__infix">
                  <input
                    type="email"
                    autocomplete="off"
                    formControlName="email"
                    required="true"
                    id="email"
                    (focus)="focusFunction()"
                    (focusout)="focusOutFunction()" />
                </div>
              </div>
              <div
                *ngIf="emailForm.controls.email.touched && emailForm.controls.email.errors"
                class="dt-f-item__message color-danger"
                role="status"
                [attr.aria-labelledby]="'input-email'"
                >{{ 'INVALID_INPUT' | translate }} E-Mail</div
              >
            </div>
            <div class="dt-l-button-group">
              <button
                type="button"
                (click)="submitPasswordRequest()"
                class="dt-c-button primary"
                [disabled]="emailForm.invalid">
                {{ 'RESET_PASSWORD' | translate }}
              </button>
              <button type="button" (click)="backToLogin()" class="dt-c-button transparent text-small">
                {{ 'BACK_TO_LOGIN' | translate }}
              </button>
            </div>
          </form>
        </ng-container>
        <ng-container *ngIf="passwordRequested">
          <h1 class="dt-l-article__section__title" tabindex="-1">
            {{ 'PAGE_HEADING' | translate }}
          </h1>
          <p class="dt-l-article__section__description">
            {{ 'PASSWORD_REQUESTED' | translate }}
          </p>
          <div class="dt-l-button-group">
            <button type="button" (click)="backToLogin()" class="dt-c-button primary">
              {{ 'BACK_TO_LOGIN' | translate }}
            </button>
          </div>
        </ng-container>
      </section>
    </div>
  </article>
</div>
